import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Typography, LinearProgress } from "@mui/material";

export const FileUploadPanel = ({
  pdfFile,
  onFileChange,
  onUpload,
  onAnalyze,
  uploadStatus,
  analysisStatus,
  disableAnalyze,
  mensajeError
}) => {
  const startTimeRef = useRef(null);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (analysisStatus === "in-progress" && !startTimeRef.current) {
      startTimeRef.current = Date.now();
    }

    if (analysisStatus === "done" && startTimeRef.current) {
      const endTime = Date.now();
      const duration = ((endTime - startTimeRef.current) / 1000).toFixed(2);
      setElapsedTime(duration);
      startTimeRef.current = null; // opcional: resetea para próximos análisis
    }

    if (analysisStatus === "error" || analysisStatus === null) {
      startTimeRef.current = null;
      setElapsedTime(0);
    }
  }, [analysisStatus]);

  const renderUploadStatus = () => {
    switch (uploadStatus) {
      case "uploading":
        return (
          <Box
            data-testid="status-upload"
            sx={{ color: "#FF9800", fontWeight: "bold", mt: 1 }}
          >
            Subiendo PDF...
          </Box>
        );
      case "uploaded":
        return (
          <Box
            data-testid="status-upload"
            sx={{ color: "green", fontWeight: "bold", mt: 1 }}
          >
            ¡PDF cargado!
          </Box>
        );
      case "error":
        return (
          <Box
            data-testid="status-upload"
            sx={{ color: "red", fontWeight: "bold", mt: 1 }}
          >
            Error al subir PDF
          </Box>
        );
      default:
        return null;
    }
  };

  const renderAnalysisStatus = () => {
    switch (analysisStatus) {
      case "in-progress":
        return (
          <Box
            data-testid="status-analysis"
            sx={{ mt: 2, width: "80%" }}
          >
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              Analizando...
            </Typography>
            <LinearProgress color="primary" />
          </Box>
        );
      case "done":
        return (
          <Box
            data-testid="status-analysis"
            sx={{ mt: 2, color: "green", fontWeight: "bold" }}
          >
            ¡Análisis completado! Tiempo total de análisis: {elapsedTime} segundos.
          </Box>
        );
      case "error":
        return (
          <Box
            data-testid="status-analysis"
            sx={{ mt: 2, color: "red", fontWeight: "bold" }}
          >
            Error durante el análisis
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", mb: 2, fontSize: "1.2rem" }}
      >
        Cargá tus requerimientos en formato PDF (máx. 4MB)
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 2
        }}
      >
        <Button
          variant="contained"
          component="label"
          sx={{
            backgroundColor: "#FFA726",
            "&:hover": { backgroundColor: "#FB8C00" }
          }}
        >
          Seleccionar archivo
          <input
            data-testid="input-pdf"
            type="file"
            hidden
            accept="application/pdf"
            onChange={onFileChange}
          />
        </Button>
        <Typography variant="body2" sx={{ minHeight: "1.5em" }}>
          {pdfFile ? pdfFile.name : "Sin archivos seleccionados"}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Button
          data-testid="btn-upload"
          variant="contained"
          sx={{
            backgroundColor: "#FFA726",
            "&:hover": { backgroundColor: "#FB8C00" }
          }}
          onClick={onUpload}
        >
          Subir
        </Button>
        <Button
          data-testid="btn-analyze"
          variant="contained"
          onClick={onAnalyze}
          disabled={disableAnalyze}
          sx={{
            backgroundColor: !disableAnalyze ? "#F57C00" : "#ccc",
            "&:hover": {
              backgroundColor: !disableAnalyze ? "#EF6C00" : "#ccc"
            }
          }}
        >
          Iniciar análisis
        </Button>
      </Box>

      {renderUploadStatus()}
      {renderAnalysisStatus()}
      {mensajeError && (
        <Box
          data-testid="error-global"
          sx={{ mt: 2, color: "red", fontWeight: "bold" }}
        >
          {mensajeError}
        </Box>
      )}
    </Box>
  );
};
